import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPassport = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.068 3.5c-.26 0-.568.246-.568.673v15.654c0 .427.307.673.568.673h11.864c.26 0 .568-.246.568-.673V4.173c0-.427-.307-.673-.568-.673zM4 4.173C4 3.028 4.873 2 6.068 2h11.864C19.127 2 20 3.028 20 4.173v15.654C20 20.972 19.127 22 17.932 22H6.068C4.873 22 4 20.972 4 19.827zm4.531 5.21h1.134c.119-.951.382-1.873.78-2.729-.965.52-1.698 1.51-1.914 2.728M12 6.895a7.7 7.7 0 0 0-.821 2.486h1.642A7.7 7.7 0 0 0 12 6.896m.821 3.986A7.7 7.7 0 0 1 12 13.368a7.7 7.7 0 0 1-.821-2.486zm-3.156 0H8.53c.216 1.218.949 2.208 1.913 2.728a9.2 9.2 0 0 1-.78-2.728m3.89 2.728c.397-.856.661-1.778.78-2.728h1.133c-.216 1.218-.948 2.208-1.913 2.728m1.913-4.228h-1.133a9.2 9.2 0 0 0-.78-2.728c.965.52 1.697 1.51 1.913 2.728m-8.502.75c0-2.913 2.2-5.375 5.034-5.375s5.034 2.462 5.034 5.375c0 2.914-2.201 5.375-5.034 5.375-2.834 0-5.034-2.461-5.034-5.375m1.62 7.471a.623.623 0 1 0 0 1.246h6.828a.623.623 0 0 0 0-1.246z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPassport;
